// Drawers (lead / student / payslip) — production-safe. Screens populate drawer
// content via dataset payloads; this binder handles open/close/backdrop only.

const OPEN = 'is-open';

function closeAll(): void {
  document.querySelectorAll('.drawer').forEach((d) => d.classList.remove(OPEN));
  const scrim = document.getElementById('scrim');
  if (scrim) scrim.classList.remove('is-visible');
  document.body.classList.remove('drawer-open');
}

function openDrawer(id: string): void {
  closeAll();
  const d = document.getElementById(id);
  if (!d) return;
  d.classList.add(OPEN);
  const scrim = document.getElementById('scrim');
  if (scrim) scrim.classList.add('is-visible');
  document.body.classList.add('drawer-open');
}

export function closeDrawer(): void { closeAll(); }

export function bindDrawerClicks(): void {
  document.addEventListener('click', (e) => {
    const t = e.target as HTMLElement;
    const closer = t.closest<HTMLElement>('[data-action="close-drawer"], [data-close-drawer]');
    if (closer) { closeAll(); return; }
    if (t.id === 'scrim') { closeAll(); return; }
    const opener = t.closest<HTMLElement>('[data-drawer]');
    if (opener && opener.dataset.drawer) { openDrawer(opener.dataset.drawer); return; }
    const payload = t.closest<HTMLElement>('[data-drawer-payload]');
    if (payload) {
      const sel = payload.dataset.drawerPayload;
      const body = sel ? document.getElementById(sel) : null;
      if (body) {
        const name = body.querySelector<HTMLElement>('#lead-name, #stu-name, #pay-name');
        if (name && payload.dataset.name) name.textContent = payload.dataset.name;
        const sub = body.querySelector<HTMLElement>('#lead-sub, #stu-sub, #pay-sub');
        if (sub && payload.dataset.sub) sub.textContent = payload.dataset.sub;
      }
    }
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
}

export function openPayslipDrawer(_emp: unknown): void { /* populated by payroll screen */ }
export function openLeadDrawer(_id: string): void {}
export function openStudentDrawer(_id: string): void {}
